module.exports = "input, select, textarea{\r\n    color: #000000;\r\n}\r\n\r\ntextarea:focus, input:focus {\r\n    color: #000000;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/mi-cuenta/mi-cuenta.component.css
// module id = ./src/app/mi-cuenta/mi-cuenta.component.css
// module chunks = main